// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__geSpy","choiceBoxes":"toolbarselects_choiceBoxes__2zGYo","simpleField":"toolbarselects_simpleField__1o7vA"};